import {
    Box, Flex, Grid, GridItem, Image, Input, Select, Text, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, FormControl, FormLabel, Button, Badge, Tooltip, Textarea, Modal,
    ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, SimpleGrid, DrawerFooter, InputGroup, InputLeftElement, Popover, PopoverTrigger, PopoverContent, PopoverBody, PopoverCloseButton, useDisclosure,
    IconButton,
} from '@chakra-ui/react'
import MyDiv from './payrollCompany.style';
import { AddIcon, ChevronDownIcon, Search2Icon, TimeIcon } from '@chakra-ui/icons';
import { AlertCard, CustomButton, CustomToast, ActionEditIcon } from '../../../../components';
import { useEffect, useRef, useState, useCallback } from 'react';
import PlusIcon from "../../../../assets/images/Vector.svg";
import { IPayrollCompany, sortOptions, sortMapping } from './model';
import { useFetch } from '../../../../hooks/useFetch';
import AddBranch from './AddBranch';
import CompanyDocumentDrawer from '../Company/CompanyDocumentDrawer';
import { useForm } from 'react-hook-form';
import MultiSelectTypeahead from '../../../../components/AutoCompleteInput/MultiSelectTypeahead';
import SortIcon from "../../../../assets/images/SortIcon.svg";
import CustomTables from '../../../../components/CustomTable/CustomTables';
import { Column, ILazyParams } from '../../../../components/CustomTable/CustomTables';
import { DirectorHistoryModal } from './directorHistory';

const GEOAPIFY_API_KEY = "e1c50744d5c64149bc15dc3e2ebc165d";

interface ICountryDropdown {
    id: number;
    country_Name: string;
    country_Code: string;
}

type ManualPerson = { id: string; name: string; isManualEntry: true; manualEmail: string; manualPhone: string };

type ManualDirectorState = { active: boolean; name: string; email: string; phone: string };

const emptyManualDirector: ManualDirectorState = { active: false, name: "", email: "", phone: "" };


const ManualDirectorRow = ({ manualDirector, setManualDirector, onAdd, onCancel, }: { manualDirector: ManualDirectorState; setManualDirector: React.Dispatch<React.SetStateAction<ManualDirectorState>>; onAdd: () => void; onCancel: () => void; }) => {
    if (!manualDirector.active) return null;
    return (
        <Box mt={2} p={3} bg="gray.50" borderRadius="md" borderWidth="1px">
            <SimpleGrid columns={2} spacing={2} mb={2}>
                <Input size="sm" placeholder="Director Name" value={manualDirector.name} onChange={(e) => setManualDirector((p) => ({ ...p, name: e.target.value }))} />
                <Input size="sm" placeholder="Email" type="email" value={manualDirector.email} onChange={(e) => setManualDirector((p) => ({ ...p, email: e.target.value }))} />
                <Input size="sm" placeholder="Phone Number" maxLength={10} value={manualDirector.phone} onChange={(e) => setManualDirector((p) => ({ ...p, phone: e.target.value }))} />
            </SimpleGrid>
            <Flex gap={2} justify="flex-end">
                <Button size="xs" variant="ghost" onClick={onCancel}>Cancel</Button>
                <Button size="xs" bg="#006838" color="white" _hover={{ bg: "#00532c" }} onClick={onAdd}>Add</Button>
            </Flex>
        </Box>
    );
};
// -----------------------------------------------------------------------------------------

const PayrollCompany = () => {
    const [employees, setEmployees] = useState<IPayrollCompany[]>([]);
    const [AlertOpen, setAlertOpen] = useState(false);
    const [DrawerOpen, setDrawerOpen] = useState(false);
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [pendingStatus, setPendingStatus] = useState<boolean | null>(null);
    const [isEditMode, setIsEditMode] = useState(false);

    const [directorHistoryModal, setDirectorHistoryModal] = useState({ open: false, payrollCompanyId: 0, companyName: "" });

    const [countries, setCountries] = useState<ICountryDropdown[]>([]);
    const [selectedCountryId, setSelectedCountryId] = useState<number | null>(null);

    const [countrySearch, setCountrySearch] = useState("");
    const [showCountryDropdown, setShowCountryDropdown] = useState(false);
    const countryRef = useRef<HTMLDivElement>(null);
    // Debounce timer for the country search so we don't fire an API call on every keystroke.
    const countryDebounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    // Manual "Add New Director" inline form state
    const [manualDirector, setManualDirector] = useState<ManualDirectorState>(emptyManualDirector);

    const [currentPayrollCompany, setCurrentPayrollCompany] =
        useState<IPayrollCompany>({
            id: 0,
            companyCode: '',
            payrollCompanyName: '',
            address: '',
            payment_Mode: '',
            payment_Type_Code: '',
            account_No: '',
            bank_Name_Id: 0,
            logo: '',
            stamp: '',
            status: true,
            header_Image: '',
            footer_Image: '',
            CIN: "",
            website: "",
            zipCode: 0,
            country: "",
            state: "",
            city: "",
        });

    const { addToast } = CustomToast();
    const { fetchApi, loading } = useFetch(addToast);
    const [statusChangeSource, setStatusChangeSource] = useState<'table' | 'drawer' | null>(null);
    const [branchDrawerOpen, setBranchDrawerOpen] = useState(false);
    const [selectedPayrollCompany, setSelectedPayrollCompany] = useState<IPayrollCompany | null>(null);
    const [logo, setLogo] = useState<File | null>(null);
    const [stamp, setStamp] = useState<File | null>(null);
    const [headerImage, setHeaderImage] = useState<File | null>(null);
    const [footerImage, setFooterImage] = useState<File | null>(null);
    const [logoPreview, setLogoPreview] = useState<string | null>(null);
    const [stampPreview, setStampPreview] = useState<string | null>(null);
    const [headerPreview, setHeaderPreview] = useState<string | null>(null);
    const [footerPreview, setFooterPreview] = useState<string | null>(null);
    const [employeeOptions, setEmployeeOptions] = useState<any[]>([]);
    const [allEmployees, setAllEmployees] = useState<any[]>([]);

    // NEW: dedicated Director options, sourced from the Director module's endpoint
    const [directorOptions, setDirectorOptions] = useState<any[]>([]);
    const [allDirectors, setAllDirectors] = useState<any[]>([]);

    const logoInputRef = useRef<HTMLInputElement>(null);
    const stampInputRef = useRef<HTMLInputElement>(null);
    const headerInputRef = useRef<HTMLInputElement>(null);
    const footerInputRef = useRef<HTMLInputElement>(null);
    const [previewImage, setPreviewImage] = useState("");
    const [imageModalOpen, setImageModalOpen] = useState(false);
    const [totalCount, setTotalCount] = useState(0);

    // Unified lazyParams — matches what CustomTable sends via onLazyParamsChange.
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 20,
        sortField: undefined,
        sortOrder: undefined,
        multiSortMeta: [],
        filters: {},
        globalFilter: '',
    });

    const { isOpen: isSortOpen, onOpen: onSortOpen, onClose: onSortClose } = useDisclosure();
    const [selectedSort, setSelectedSort] = useState<string>(sortOptions[0]);

    const openImage = (image: string) => { setPreviewImage(image); setImageModalOpen(true); };

    const [documentDrawerOpen, setDocumentDrawerOpen] = useState(false);

    type FormValues = {
        directors: any[];
        auditors: any[];
        pfConsultants: any[];
    };

    const { control, setValue, watch, reset } = useForm<FormValues>({
        defaultValues: {
            directors: [],
            auditors: [],
            pfConsultants: [],
        },
    });


    const handleOpenDocumentMapping = (row: any) => {
        setSelectedPayrollCompany(row);
        setDocumentDrawerOpen(true);
    };

    // Fires on initial load AND whenever the table's sort/filter/search/page changes.
    useEffect(() => { loadPayrollCompany(lazyParams); }, [lazyParams]);

    const loadPayrollCompany = async (params: ILazyParams) => {
        const qs = new URLSearchParams();
        qs.set('first', String(params.first));
        qs.set('rows', String(params.rows));
        if (params.sortField) qs.set('sortField', params.sortField);
        if (params.sortOrder) qs.set('sortOrder', String(params.sortOrder));
        if (params.globalFilter) qs.set('globalFilter', params.globalFilter);
        if (params.filters && Object.keys(params.filters).length) {
            qs.set('filters', JSON.stringify(params.filters));
        }

        const response = await fetchApi<{ data: IPayrollCompany[]; totalRecords: number }>(
            `Hrlense_PayrollCompany?${qs.toString()}`, "GET"
        );

        if (response) {
            setEmployees(response.data);
            setTotalCount(response.totalRecords);
        }
    };
    const loadEmployeesDropdown = async () => {
        const response = await fetchApi<any[]>("Hrlense_Company/GetEmployeesDropdown", "GET");

        if (response) {
            setEmployeeOptions(response);
            setAllEmployees(response);
        }
    };

    // NEW: load directors from the same endpoint the Director module uses,
    // so the Payroll Company drawer's Director field only ever shows directors.
    const loadDirectorsDropdown = async () => {
        const response = await fetchApi<any[]>("Director/directorsDropdown", "GET");

        if (response) {
            setDirectorOptions(response);
            setAllDirectors(response);
        }
    };

    const handleStatusChange = (id: number, newStatus: boolean) => {
        setSelectedId(id);
        setPendingStatus(newStatus);
        setStatusChangeSource('table');
        setAlertOpen(true);
    };

    const handleLogoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files?.[0]) {
            setLogo(e.target.files[0]);
        }
    };

    const handleStampChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files?.[0]) {
            setStamp(e.target.files[0]);
        }
    };

    const handleheaderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files?.[0]) {
            setHeaderImage(e.target.files[0]);
        }
    };

    const handlefooterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files?.[0]) {
            setFooterImage(e.target.files[0]);
        }
    };


    useEffect(() => {
        const previews: { file?: File | null; set: (url: string) => void }[] = [
            { file: logo, set: setLogoPreview },
            { file: stamp, set: setStampPreview },
            { file: headerImage, set: setHeaderPreview },
            { file: footerImage, set: setFooterPreview },
        ];

        const urls: string[] = [];

        previews.forEach(({ file, set }) => {
            if (file) {
                const url = URL.createObjectURL(file);
                urls.push(url);
                set(url);
            }
        });

        return () => {
            urls.forEach((url) => URL.revokeObjectURL(url));
        };
    }, [logo, stamp, headerImage, footerImage]);


    const handleDrawerStatusChange = (newStatus: boolean) => {
        setPendingStatus(newStatus);
        setStatusChangeSource('drawer');
        setAlertOpen(true);
    };

    const handleConfirmStatusChange = async () => {
        if (selectedId !== null && pendingStatus !== null) {
            const scoreId = statusChangeSource === "table" ? selectedId : currentPayrollCompany.id;

            const response = await fetchApi(`Hrlense_PayrollCompany/toggleStatus/${scoreId}`, "PUT", { id: scoreId, status: pendingStatus }, null, "PayrollCompany updated successfully");
            if (response) {
                if (statusChangeSource === "table") {
                    setEmployees((prev) => prev.map((employees) => employees.id === selectedId ? { ...employees, status: pendingStatus } : employees));
                } else {
                    setCurrentPayrollCompany((prev) => ({ ...prev, status: pendingStatus }));
                }
            }
        }
        setAlertOpen(false);
    };
    const emptyPayrollCompany: IPayrollCompany = {
        id: 0,
        companyCode: '',
        payrollCompanyName: '',
        address: '',
        payment_Mode: '',
        payment_Type_Code: '',
        account_No: '',
        bank_Name_Id: 0,
        logo: '',
        stamp: '',
        header_Image: '',
        footer_Image: '',
        status: true,
        CIN: "",
        website: "",
        city: "",
        zipCode: 0,
        country: "",
        state: "",
        directors: [],
        auditors: [],
        pfConsultants: [],
    };

    const handleAddPayroll = () => {
        resetFiles();
        setIsEditMode(false);
        setCurrentPayrollCompany(emptyPayrollCompany);
        setDrawerOpen(true);
        setManualDirector(emptyManualDirector);
        reset({
            directors: [],
            auditors: [],
            pfConsultants: [],
        });
    };
    const handleEditPayroll = (row: IPayrollCompany) => {
        resetFiles();
        setIsEditMode(true);
        setSelectedId(row.id);
        setCurrentPayrollCompany(row);
        setDrawerOpen(true);
        setManualDirector(emptyManualDirector);
        setValue("directors", row.directors || []);
        setValue("auditors", row.auditors || []);
        setValue("pfConsultants", row.pfConsultants || []);
    };


    const handleInputChange = (e: any) => {
        const { name, value } = e.target;
        if (name === "payrollCompanyName" && !/^[A-Za-z\s]*$/.test(value)) {
            return;
        }
        if (name === "payment_Mode" && !/^[A-Za-z\s]*$/.test(value)) {
            return;
        }
        if (name === "account_No" && !/^\d*$/.test(value)) {
            return;
        }
        if (name === "city" && !/^[A-Za-z\s]*$/.test(value)) {
            return;
        }
        if (name === "country" && !/^[A-Za-z\s]*$/.test(value)) {
            return;
        }
        if (name === "state" && !/^[A-Za-z\s]*$/.test(value)) {
            return;
        }
        if (name === "zipCode" && !/^\d*$/.test(value)) {
            return;
        }
        if (name === "bank_Name_Id") {
            setCurrentPayrollCompany(prev => ({
                ...prev,
                bank_Name_Id: Number(value) || 0
            }));
            return;
        }
        setCurrentPayrollCompany(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const resetFiles = () => {
        setLogo(null);
        setStamp(null);
        setLogoPreview(null);
        setStampPreview(null);
        setHeaderImage(null);
        setFooterImage(null);
        setHeaderPreview(null);
        setFooterPreview(null);

        if (logoInputRef.current) logoInputRef.current.value = "";
        if (stampInputRef.current) stampInputRef.current.value = "";
        if (headerInputRef.current) headerInputRef.current.value = "";
        if (footerInputRef.current) footerInputRef.current.value = "";
    };

    // ---- Manual "Add New Director" handlers ----
    const openManualDirector = () => setManualDirector({ active: true, name: "", email: "", phone: "" });
    const cancelManualDirector = () => setManualDirector(emptyManualDirector);

    const addManualDirector = () => {
        if (!manualDirector.name.trim()) {
            addToast({ message: "Please enter a director name", status: "warning" });
            return;
        }
        if (manualDirector.phone && !/^\d{10}$/.test(manualDirector.phone)) {
            addToast({ message: "Phone number must be 10 digits", status: "warning" });
            return;
        }

        if (manualDirector.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(manualDirector.email)) {
            addToast({ message: "Please enter a valid email address", status: "warning" });
            return;
        }

        const newDirector: ManualPerson = {
            id: `manual-${Date.now()}`,
            name: manualDirector.name.trim(),
            isManualEntry: true,
            manualEmail: manualDirector.email.trim(),
            manualPhone: manualDirector.phone.trim(),
        };
        const current = watch("directors") || [];
        setValue("directors", [...current, newDirector] as any);
        cancelManualDirector();
    };

    const splitDirectors = (list: any[]) => {
        const ids = (list || []).filter((x) => !x.isManualEntry).map((x) => x.id);
        const manual = (list || [])
            .filter((x) => x.isManualEntry)
            .map((x) => ({ name: x.name, email: x.manualEmail || "", phone: x.manualPhone || "" }));
        return { ids, manual };
    };
    // ---------------------------------------------


    const handleSubmit = async () => {
        const formData = new FormData();
        const directors = watch("directors") || [];
        const auditors = watch("auditors") || [];
        const pfConsultants = watch("pfConsultants") || [];
        const { ids: directorId, manual: manualDirectors } = splitDirectors(directors);
        const auditorId = auditors.map((x: any) => x.id);
        const pfConsultantId = pfConsultants.map((x: any) => x.id);
        if (!currentPayrollCompany.payrollCompanyName.trim()) {
            addToast({ message: "Please enter Payroll Company Name", status: "warning" });
            return;
        }
        if (!currentPayrollCompany.zipCode || currentPayrollCompany.zipCode === 0) {
            addToast({ message: "Please enter the zip code", status: "warning", });
            return;
        }
        if (!currentPayrollCompany.country.trim()) {
            addToast({ message: "Please enter Country", status: "warning" });
            return;
        }
        if (!currentPayrollCompany.state.trim()) {
            addToast({ message: "Please enter State", status: "warning" });
            return;
        }
        if (!currentPayrollCompany.city.trim()) {
            addToast({ message: "Please enter City", status: "warning" });
            return;
        }
        if (!currentPayrollCompany.address.trim()) {
            addToast({ message: "Please enter Address", status: "warning" });
            return;
        }
        formData.append("companyCode", currentPayrollCompany.companyCode);
        formData.append("payrollCompanyName", currentPayrollCompany.payrollCompanyName);
        formData.append("address", currentPayrollCompany.address);
        formData.append("payment_Mode", currentPayrollCompany.payment_Mode);
        formData.append("payment_Type_Code", currentPayrollCompany.payment_Type_Code);
        formData.append("account_No", currentPayrollCompany.account_No);
        formData.append("zipCode", String(currentPayrollCompany.zipCode));
        formData.append("country", currentPayrollCompany.country);
        formData.append("state", currentPayrollCompany.state);
        formData.append("city", currentPayrollCompany.city);
        formData.append("bank_Name_Id", String(currentPayrollCompany.bank_Name_Id));
        formData.append("status", String(currentPayrollCompany.status));
        formData.append("CIN", currentPayrollCompany.CIN);
        formData.append("website", currentPayrollCompany.website);
        directorId.forEach((id: number) => formData.append("DirectorId", id.toString()));
        auditorId.forEach((id: number) => formData.append("AuditorId", id.toString()));
        pfConsultantId.forEach((id: number) => formData.append("PfConsultantId", id.toString()));
        if (manualDirectors.length) formData.append("ManualDirectors", JSON.stringify(manualDirectors));
        if (logo) formData.append("logo", logo);
        if (stamp) formData.append("stamp", stamp);
        if (headerImage) formData.append("header_image", headerImage);
        if (footerImage) formData.append("footer_image", footerImage);
        if (isEditMode) {
            formData.append("id", String(currentPayrollCompany.id));
            const response = await fetchApi<IPayrollCompany>(`Hrlense_PayrollCompany/${currentPayrollCompany.id}`, "PUT", formData, null, "Payroll Company updated successfully", true);
            if (!response) return;

        } else {
            const response = await fetchApi<IPayrollCompany>("Hrlense_PayrollCompany", "POST", formData, null, "Payroll Company added successfully", true);
            if (!response) return;

        }
        await loadPayrollCompany(lazyParams);
        setDrawerOpen(false);
    };


    const getStatusColor = (status: boolean) => (status ? "#38A169" : "#E53E3E");

    const handleAddBranch = (row: IPayrollCompany) => {
        setSelectedPayrollCompany(row);
        setBranchDrawerOpen(true);
    };

    const handleEmployeeSearch = (query?: string) => {
        if (!query) {
            setEmployeeOptions(allEmployees);
            return;
        }
        const filtered = allEmployees.filter((emp) => emp.name.toLowerCase().includes(query.toLowerCase()));
        setEmployeeOptions(filtered);
    };

    // NEW: search handler scoped to the director-only list
    const handleDirectorSearch = (query?: string) => {
        if (!query) {
            setDirectorOptions(allDirectors);
            return;
        }
        const filtered = allDirectors.filter((d) => d.name.toLowerCase().includes(query.toLowerCase()));
        setDirectorOptions(filtered);
    };

    useEffect(() => {
        loadEmployeesDropdown();
        loadDirectorsDropdown();
    }, []);

    const fetchCountries = useCallback(async (text: string) => {
        const response = await fetchApi<ICountryDropdown[]>(text ? `DropDown/country?filter=${encodeURIComponent(text)}` : `DropDown/country`, "GET");
        if (response) {
            setCountries(response);
            setShowCountryDropdown(text.trim().length > 0);
        }
    }, [fetchApi]);

    const handleCountrySearch = (text: string = "") => {
        setCountrySearch(text);

        if (countryDebounceRef.current) {
            clearTimeout(countryDebounceRef.current);
        }

        if (!text.trim()) {
            setShowCountryDropdown(false);
            return;
        }

        countryDebounceRef.current = setTimeout(() => {
            fetchCountries(text);
        }, 300);
    };

    useEffect(() => {
        return () => {
            if (countryDebounceRef.current) {
                clearTimeout(countryDebounceRef.current);
            }
        };
    }, []);

    const handleZipCodeBlur = async () => {

        if (!currentPayrollCompany.zipCode) return;
        const selectedCountry = countries.find(c => c.id === selectedCountryId);
        if (!selectedCountry) {
            addToast({ message: "Please select a Country before entering Zip Code", status: "warning" });
            return;
        }
        try {
            const res = await fetch(
                `https://api.geoapify.com/v1/geocode/search` +
                `?text=${encodeURIComponent(currentPayrollCompany.zipCode)}` +
                `&type=postcode` +
                `&filter=countrycode:${selectedCountry.country_Code.toLowerCase()}` +
                `&format=json&apiKey=${GEOAPIFY_API_KEY}`
            );


            const data = await res.json();
            const result = data?.results?.[0];

            if (result) {
                setCurrentPayrollCompany(prev => ({
                    ...prev,
                    country: selectedCountry.country_Name,
                    state: result.state || "",
                    city: result.city || result.county || "",
                }));
            } else {
                addToast({
                    message: `No match found for that postal code in ${selectedCountry.country_Name}. Please enter State/City manually.`,
                    status: "warning",
                });
                setCurrentPayrollCompany(prev => ({ ...prev, state: "", city: "" }));
            }
        } catch {
            addToast({ message: "Failed to fetch location details", status: "error" });
        }
    };

    const isValidImage = (url?: string | null) => {
        return !!url && url !== "not found" && url !== "null" && url !== "undefined";
    };

    // "Sort By" popover writes into the SAME lazyParams the table uses, so it stays
    // in sync with whatever a user does by clicking a column header directly.
    const handleSortSelect = (option: string) => {
        setSelectedSort(option);
        const { field, order } = sortMapping[option];
        setLazyParams(prev => ({ ...prev, sortField: field, sortOrder: order as 1 | -1, first: 0 }));
        onSortClose();
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                countryRef.current &&
                !countryRef.current.contains(event.target as Node)
            ) {
                setShowCountryDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () =>
            document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <MyDiv>
            <Flex className="page_heading flex_header" >
                <Text className="font-poppins text_semibold text_3xl">Payroll Company List</Text>
                <Flex gap={2}>
                    <Popover isOpen={isSortOpen} onOpen={onSortOpen} onClose={onSortClose} placement="bottom-end" closeOnBlur>
                        <PopoverTrigger>
                            <Image src={SortIcon} alt="Sort" className="icon_btn" cursor="pointer" />
                        </PopoverTrigger>
                        <PopoverContent w="220px" borderRadius="10px" boxShadow="md">
                            <Box px={4} py={2} borderBottom="1px solid #eee">
                                <Text className="font-poppins text_sm text_medium" textAlign="center" color="#00000080">Sort By</Text>
                                <PopoverCloseButton top="8px" right="12px" />
                            </Box>
                            <PopoverBody p={0}>
                                {sortOptions.map((option) => (
                                    <Box key={option} px={4} py={2} cursor="pointer" bg={selectedSort === option ? "#EBEBEB" : "white"} _hover={{ bg: "#EBEBEB" }} onClick={() => handleSortSelect(option)}
                                    >
                                        <Text className="font-poppins font_dark" fontSize="14px" fontWeight="500">{option}</Text>
                                    </Box>
                                ))}
                            </PopoverBody>
                        </PopoverContent>
                    </Popover>
                    <CustomButton title="Add New Payroll Company" className=' btn font-poppins text_sm text_medium' rightIcon={<Image src={PlusIcon} className='logo' />} onClick={handleAddPayroll} />
                </Flex>
            </Flex>
            <Grid className='grid_container'>
                <GridItem colSpan={12}>
                    <CustomTables<IPayrollCompany>
                        value={employees}
                        loading={loading}
                        emptyMessage="No Payroll Companies Found"
                        preferenceKey="payrollCompanyList"
                        showGlobalSearch={false}
                        showToolbar={true}
                        lazy
                        lazyParams={lazyParams}
                        onLazyParamsChange={setLazyParams}
                        totalRecords={totalCount}
                        showPagination
                        rowsPerPageOptions={[20, 100, 200, 500]}
                        maxTableHeight={null}
                    >
                        <Column header="S. No" body={(_, idx) => lazyParams.first + idx + 1} width={70} />

                        <Column
                            header="Company Code"
                            field="companyCode"
                            sortable
                            filterable
                            filterType="text"
                            body={(row: any) => (
                                <Badge variant="subtle" className="empId font-poppins text_sm text_medium" onClick={() => handleEditPayroll(row)} cursor="pointer" >
                                    {row.companyCode}
                                </Badge>
                            )}
                        />

                        <Column
                            header="Payroll Company Name"
                            field="payrollCompanyName"
                            sortable
                            filterable
                            filterType="text"
                            frozen="left"
                            body={(rowData: any) => (
                                <Tooltip label={rowData.payrollCompanyName} hasArrow placement="top">
                                    <Text maxW="180px" isTruncated cursor="pointer"  >
                                        {rowData.payrollCompanyName}
                                    </Text>
                                </Tooltip>
                            )}
                        />

                        {/* <Column header="CIN" field="cin" sortable filterable filterType="text" />
                        <Column header="Website" field="website" sortable filterable filterType="text" />
                        <Column header="Payment Mode" field="payment_Mode" sortable filterable filterType="text" />
                        <Column header="Payment Type Code" field="payment_Type_Code" />
                        <Column header="Account No" field="account_No" /> */}
                        <Column header="CIN" field="cin" sortable filterable filterType="text" body={(row) => (row.cin ? row.cin : "N/A")} />
                        <Column header="Website" field="website" sortable filterable filterType="text" body={(row) => (row.website ? row.website : "N/A")} />
                        <Column header="Payment Mode" field="payment_Mode" sortable filterable filterType="text" body={(row) => (row.payment_Mode ? row.payment_Mode : "N/A")} />
                        <Column header="Payment Type Code" field="payment_Type_Code" body={(row) => (row.payment_Type_Code ? row.payment_Type_Code : "N/A")} />
                        <Column header="Account No" field="account_No" body={(row) => (row.account_No ? row.account_No : "N/A")} />
                        <Column header="Bank Name Id" field="bank_Name_Id" />

                        <Column header="Country" field="country" sortable filterable filterType="text" body={(row) => row.country || "N/A"} />
                        <Column header="State" field="state" sortable filterable filterType="text" body={(row) => row.state || "N/A"} />
                        <Column header="City" field="city" sortable filterable filterType="text" body={(row) => row.city || "N/A"} />
                        <Column header="Zip Code" field="zipCode" sortable filterable filterType="number" />

                        <Column header="Address" field="address" body={(row: any) => (
                            <Tooltip label={row.address} aria-label="Full address" bg="gray.700" color="white" placement="bottom-start" maxW="300px" hasArrow   >
                                <Box as="span" display="inline-block" maxWidth="9vw" isTruncated>
                                    {row.address}
                                </Box>
                            </Tooltip>
                        )}
                        />

                        <Column header="Director Name" field="directors" body={(row: any) => {
                            const directors =
                                row.directors?.length > 0 ? row.directors.map((x: any) => x.name).join(", ") : "N/A";
                            return (<Tooltip label={directors} hasArrow><Text isTruncated maxW="8vw">{directors} </Text> </Tooltip>);
                        }}
                        />
                        <Column header="Auditor Name" field="auditors" body={(row: any) => {
                            const auditors = row.auditors?.length > 0 ? row.auditors.map((x: any) => x.name).join(", ") : "N/A";
                            return (<Tooltip label={auditors} hasArrow> <Text isTruncated maxW="8vw">   {auditors} </Text> </Tooltip>
                            );
                        }}
                        />

                        <Column header="PF Consultant Name" field="pfConsultants" body={(row: any) => {
                            const consultants = row.pfConsultants?.length > 0 ? row.pfConsultants.map((x: any) => x.name).join(", ") : "N/A";
                            return (<Tooltip label={consultants} hasArrow> <Text isTruncated maxW="8vw"> {consultants} </Text> </Tooltip>
                            );
                        }}
                        />
                        {/* <Column header="Auditor Name" field="auditors" body={(row: any) => (
                            <Tooltip label={row.auditors?.map((x: any) => x.name).join(", ")} hasArrow >
                                <Text isTruncated maxW="8vw">
                                    {row.auditors?.map((x: any) => x.name).join(", ")}
                                </Text>
                            </Tooltip>
                        )}
                        />
                        <Column header="PF Consultant Name" field="pfConsultants" body={(row: any) => (
                            <Tooltip label={row.pfConsultants?.map((x: any) => x.name).join(", ")} hasArrow >
                                <Text isTruncated maxW="8vw">
                                    {row.pfConsultants?.map((x: any) => x.name).join(", ")}
                                </Text>
                            </Tooltip>
                        )}
                        /> */}

                        <Column header="Status" field="status" filterable filterType="boolean" body={(row: any) => (
                            <Select value={row.status ? "true" : "false"} onChange={(e) => handleStatusChange(row.id, e.target.value === "true")} width="120px" height="32px" icon={<ChevronDownIcon />} borderRadius="4px" color={getStatusColor(row.status)} className="font-poppins text_medium text_xsm"><option value="true" style={{ color: "#38A169" }}>Active</option>
                                <option value="false" style={{ color: "#E53E3E" }}>Inactive</option>
                            </Select>
                        )}
                        />

                        <Column
                            header="Actions"
                            frozen="right"
                            width={160}
                            body={(row: any) => (
                                <Flex align="center" gap={2}>
                                    <Tooltip label="Edit Payroll Company" hasArrow bg="gray.700" color="white">
                                        <Box as="span" cursor="pointer">
                                            <ActionEditIcon onClick={() => handleEditPayroll(row)} />
                                        </Box>
                                    </Tooltip>

                                    <Tooltip label="Add Branch" hasArrow >
                                        <Box as="span" cursor="pointer" onClick={() => handleAddBranch(row)}>
                                            <AddIcon boxSize={3} color="green.600" />
                                        </Box>
                                    </Tooltip>

                                    <Tooltip label="Assign Documents">
                                        <Box cursor="pointer" bg="#006838" color="white" p="6px" borderRadius="md" onClick={() => handleOpenDocumentMapping(row)}>
                                            <AddIcon boxSize={3} />
                                        </Box>
                                    </Tooltip>

                                    <Tooltip label="Director History" placement="top">
                                        <IconButton
                                            size="xs"
                                            colorScheme="blue"
                                            variant="outline"
                                            aria-label="Director History"
                                            icon={<TimeIcon />}
                                            onClick={() => setDirectorHistoryModal({ open: true, payrollCompanyId: row.id, companyName: row.payrollCompanyName })} />
                                    </Tooltip>
                                </Flex>
                            )}
                        />

                        <Column header="Logo" hidden body={(row: any) => row.logo ? (
                            <Button size="xs" colorScheme="green" onClick={() => openImage(row.logo)} >  View </Button>
                        ) : ("-")} />
                        <Column header="Stamp" hidden body={(row: any) => row.stamp ? (
                            <Button size="xs" colorScheme="green" onClick={() => openImage(row.stamp)} > View </Button>
                        ) : ("-")} />
                        <Column header="Header Image" hidden body={(row: any) => row.header_Image ? (
                            <Button size="xs" colorScheme="green" onClick={() => openImage(row.header_Image)} >  View</Button>
                        ) : ("-")}
                        />
                        <Column header="Footer Image" hidden body={(row: any) => row.footer_Image ? (
                            <Button size="xs" colorScheme="green" onClick={() => openImage(row.footer_Image)} > View </Button>
                        ) : ("-")}
                        />

                    </CustomTables>
                </GridItem>
            </Grid>
            <AlertCard isOpen={AlertOpen} onClose={() => setAlertOpen(false)} onConfirm={handleConfirmStatusChange} />
            <Drawer isOpen={DrawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="lg">
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader borderBottomWidth="1px">{isEditMode ? 'Edit Payroll Company' : 'Add New Payroll Company'}</DrawerHeader>
                    <DrawerBody display="flex" flexDirection="column" justifyContent="space-between" height="100%">
                        <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                            <GridItem>
                                <FormControl >
                                    <FormLabel>Company Code</FormLabel>
                                    <Input name="companyCode" value={currentPayrollCompany.companyCode} onChange={handleInputChange} placeholder="Enter Company Code" />
                                </FormControl>
                            </GridItem>
                            <GridItem>
                                <FormControl >
                                    <FormLabel>CIN</FormLabel>
                                    <Input name="CIN" value={currentPayrollCompany.CIN} onChange={handleInputChange} placeholder="Enter CIN" />
                                </FormControl>
                            </GridItem>
                            <GridItem>
                                <FormControl >
                                    <FormLabel>Website</FormLabel>
                                    <Input name="website" value={currentPayrollCompany.website} onChange={handleInputChange} placeholder="Enter Website" />
                                </FormControl>
                            </GridItem>
                            <GridItem>
                                <FormControl>
                                    <FormLabel>Payroll Company Name</FormLabel>
                                    <Input name="payrollCompanyName" value={currentPayrollCompany.payrollCompanyName} onChange={handleInputChange} placeholder="Enter Payroll Company Name" />
                                </FormControl>
                            </GridItem>
                            <GridItem>
                                <FormControl >
                                    <FormLabel>Payment Mode</FormLabel>
                                    <Input name="payment_Mode" value={currentPayrollCompany.payment_Mode} onChange={handleInputChange} placeholder="Enter Payment Mode Name" />
                                </FormControl>
                            </GridItem>
                            <GridItem>
                                <FormControl>
                                    <FormLabel>payment Type Code</FormLabel>
                                    <Input name="payment_Type_Code" value={currentPayrollCompany.payment_Type_Code} onChange={handleInputChange} placeholder="Enter payment Type Code Name" />
                                </FormControl>
                            </GridItem>
                            <GridItem>
                                <FormControl >
                                    <FormLabel>Account No</FormLabel>
                                    <Input name="account_No" value={currentPayrollCompany.account_No} onChange={handleInputChange} placeholder="Enter Account No  Name" />
                                </FormControl>
                            </GridItem>
                            <GridItem>
                                <FormControl >
                                    <FormLabel>Bank Name Id</FormLabel>
                                    <Input name="bank_Name_Id" value={currentPayrollCompany.bank_Name_Id} onChange={handleInputChange} placeholder="Enter Bank Name Id  Name" />
                                </FormControl>
                            </GridItem>

                            <GridItem>
                                <FormControl>
                                    <FormLabel>Country</FormLabel>

                                    <Box position="relative" ref={countryRef}>
                                        <Input
                                            placeholder="Search Country"
                                            value={currentPayrollCompany.country}
                                            onChange={(e) => {
                                                setCurrentPayrollCompany(prev => ({
                                                    ...prev,
                                                    country: e.target.value
                                                }));

                                                handleCountrySearch(e.target.value);
                                            }}
                                        />

                                        {showCountryDropdown && countries.length > 0 && (
                                            <Box
                                                position="absolute"
                                                top="100%"
                                                left={0}
                                                right={0}
                                                bg="white"
                                                border="1px solid #ddd"
                                                borderRadius="6px"
                                                mt={1}
                                                maxH="220px"
                                                overflowY="auto"
                                                zIndex={9999}
                                                boxShadow="md"
                                            >
                                                {countries.map(country => (
                                                    <Box
                                                        key={country.id}
                                                        px={3}
                                                        py={2}
                                                        cursor="pointer"
                                                        _hover={{ bg: "gray.100" }}
                                                        onClick={() => {
                                                            setSelectedCountryId(country.id);

                                                            setCurrentPayrollCompany(prev => ({
                                                                ...prev,
                                                                country: country.country_Name,
                                                                state: "",
                                                                city: ""
                                                            }));

                                                            setShowCountryDropdown(false);
                                                        }}
                                                    >
                                                        {country.country_Name}
                                                    </Box>
                                                ))}
                                            </Box>
                                        )}
                                    </Box>
                                </FormControl>
                            </GridItem>
                            <GridItem>
                                <FormControl >
                                    <FormLabel>Zip Code</FormLabel>
                                    <Input
                                        name="zipCode"
                                        value={currentPayrollCompany.zipCode === 0 ? "" : currentPayrollCompany.zipCode}
                                        onChange={handleInputChange}
                                        onBlur={handleZipCodeBlur}
                                        isDisabled={!selectedCountryId}
                                        placeholder="Enter Zip Code"
                                    />                                </FormControl>
                            </GridItem>
                            <GridItem>
                                <FormControl>
                                    <FormLabel>State</FormLabel>
                                    <Input name="state" value={currentPayrollCompany.state} onChange={handleInputChange} placeholder="Auto-filled from Zip Code" />
                                </FormControl>
                            </GridItem>
                            <GridItem>
                                <FormControl >
                                    <FormLabel>City</FormLabel>
                                    <Input name="city" value={currentPayrollCompany.city} onChange={handleInputChange} placeholder="Auto-filled from Zip Code"
                                    />
                                </FormControl>
                            </GridItem>

                            <GridItem>
                                <FormControl >
                                    <FormLabel>Address</FormLabel>
                                    <Textarea name="address" value={currentPayrollCompany.address} onChange={handleInputChange} placeholder="Enter Address" />
                                </FormControl>
                            </GridItem>
                            <GridItem>
                                <FormControl>
                                    <Flex justify="space-between" align="center">
                                        <FormLabel mb={0}>Director Name</FormLabel>
                                        {!manualDirector.active && (
                                            <Button
                                                size="xs"
                                                variant="link"
                                                color="#006838"
                                                leftIcon={<AddIcon boxSize={2.5} />}
                                                onMouseDown={(e) => {
                                                    e.preventDefault();
                                                    (document.activeElement as HTMLElement)?.blur?.();
                                                    openManualDirector();
                                                }}
                                            >
                                                Add New
                                            </Button>
                                        )}
                                    </Flex>

                                    <MultiSelectTypeahead
                                        name="directors" control={control} options={directorOptions} loading={loading}
                                        onCompletion={handleDirectorSearch} optionLabel="name" optionValue="id" placeholder="Select Director"
                                    />
                                    <ManualDirectorRow manualDirector={manualDirector} setManualDirector={setManualDirector} onAdd={addManualDirector} onCancel={cancelManualDirector} />
                                </FormControl>
                            </GridItem>
                            <GridItem>
                                <FormControl >
                                    <FormLabel>Auditor Name</FormLabel>
                                    <MultiSelectTypeahead name="auditors" control={control} options={employeeOptions} loading={loading} onCompletion={handleEmployeeSearch} optionLabel="name" optionValue="id" placeholder="Select Auditor" />
                                </FormControl>
                            </GridItem>

                            <GridItem>
                                <FormControl >
                                    <FormLabel>PF Consultant Name</FormLabel>
                                    <MultiSelectTypeahead name="pfConsultants" control={control} options={employeeOptions} loading={loading} onCompletion={handleEmployeeSearch} optionLabel="name" optionValue="id" placeholder="Select PF Consultant" />
                                </FormControl>
                            </GridItem>


                            <GridItem colSpan={2}>
                                <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} gap={4} >
                                    <Box>
                                        <Text fontWeight="bold" mb={2}>Payroll Company Logo</Text>

                                        <Input type="file" ref={logoInputRef} onChange={handleLogoChange} accept="image/*" p={1} h="40px" />

                                        {logoPreview ? (
                                            <Image mt={2} src={logoPreview} boxSize="90px" objectFit="contain" border="1px solid #ddd" borderRadius="md" />
                                        ) : isEditMode && isValidImage(currentPayrollCompany.logo) ? (
                                            <Image mt={2} src={currentPayrollCompany.logo} boxSize="90px" objectFit="contain" border="1px solid #ddd" borderRadius="md"
                                                fallback={<Text fontSize="sm">No Image </Text>}
                                                onError={(e) => { e.currentTarget.style.display = "none"; }}
                                            />
                                        ) : (
                                            <Text fontSize="sm" color="gray.500">  No Image </Text>
                                        )}
                                    </Box>

                                    <Box>
                                        <Text fontWeight="bold" mb={2}>Payroll Company Stamp</Text>
                                        <Input type="file" ref={stampInputRef} onChange={handleStampChange} accept="image/*" p={1} />
                                        {stampPreview ? (
                                            <Image mt={2} src={stampPreview} boxSize="90px" objectFit="contain" border="1px solid #ddd" borderRadius="md" />
                                        ) : isEditMode &&
                                            currentPayrollCompany.stamp && currentPayrollCompany.stamp !== "not found" && currentPayrollCompany.stamp !== "null" ? (
                                            <Image mt={2} src={currentPayrollCompany.stamp} boxSize="90px" objectFit="contain" border="1px solid #ddd"
                                                borderRadius="md"
                                                onError={(e) => { e.currentTarget.style.display = "none" }}
                                            />
                                        ) : (
                                            <Text fontSize="sm" color="gray.500">  No Image  </Text>
                                        )}
                                    </Box>

                                    <Box>
                                        <Text fontWeight="bold" mb={2}>Header Image</Text>
                                        <Input type="file" ref={headerInputRef} onChange={handleheaderChange} accept="image/*" p={1} />

                                        {headerPreview ? (
                                            <Image mt={2} src={headerPreview} boxSize="90px" objectFit="contain" border="1px solid #ddd" borderRadius="md" />
                                        ) : isEditMode &&
                                            currentPayrollCompany.header_Image &&
                                            currentPayrollCompany.header_Image !== "not found" &&
                                            currentPayrollCompany.header_Image !== "null" ? (
                                            <Image mt={2} src={currentPayrollCompany.header_Image} boxSize="90px" objectFit="contain" border="1px solid #ddd" borderRadius="md" onError={(e) => { e.currentTarget.style.display = "none"; }}
                                            />
                                        ) : (
                                            <Text fontSize="sm" color="gray.500">  No Image  </Text>
                                        )}
                                    </Box>

                                    <Box>
                                        <Text fontWeight="bold" mb={2}>Footer Image</Text>
                                        <Input type="file" ref={footerInputRef} onChange={handlefooterChange} accept="image/*" p={1} />

                                        {footerPreview ? (
                                            <Image mt={2} src={footerPreview} boxSize="90px" objectFit="contain" border="1px solid #ddd" borderRadius="md" />
                                        ) : isEditMode &&
                                            currentPayrollCompany.footer_Image &&
                                            currentPayrollCompany.footer_Image !== "not found" &&
                                            currentPayrollCompany.footer_Image !== "null" ? (
                                            <Image mt={2} src={currentPayrollCompany.footer_Image} boxSize="90px" objectFit="contain" border="1px solid #ddd" borderRadius="md" onError={(e) => {
                                                e.currentTarget.style.display = "none";
                                            }}
                                            />
                                        ) : (
                                            <Text fontSize="sm" color="gray.500">   No Image found </Text>
                                        )}
                                    </Box>

                                </Grid>
                            </GridItem>

                            <GridItem colSpan={2}>
                                <FormControl mb={2}>
                                    <FormLabel>Status</FormLabel>
                                    <Select w="120px" value={currentPayrollCompany.status ? "true" : "false"} onChange={(e) => handleDrawerStatusChange(e.target.value === "true")} color={getStatusColor(currentPayrollCompany.status)}>
                                        <option value="true" style={{ color: "#38A169" }}> Active</option>
                                        <option value="false" style={{ color: "#E53E3E" }}>Inactive</option>
                                    </Select>
                                </FormControl>
                            </GridItem>
                        </Grid>
                    </DrawerBody>
                    <DrawerFooter>
                        <Flex justify="flex-end" mt={4} gap={2}>
                            <Button className="font-poppins text_sm text_medium" onClick={() => setDrawerOpen(false)} style={{ backgroundColor: '#D92F34', color: 'white' }}  >
                                Cancel
                            </Button>
                            <Button onClick={handleSubmit} isLoading={loading} className="font-poppins text_sm text_medium" style={{ backgroundColor: '#006838', color: 'white' }} >
                                {isEditMode ? "Update Payroll Company" : "Add Payroll Company"}
                            </Button>
                        </Flex>
                    </DrawerFooter>
                </DrawerContent>
            </Drawer>

            <Modal isOpen={imageModalOpen} onClose={() => setImageModalOpen(false)} size="xl" isCentered  >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Image Preview</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>
                        <Image src={previewImage} alt="Preview" w="100%" maxH="500px" objectFit="contain" fallback={<Text>Image not found</Text>} />
                    </ModalBody>
                </ModalContent>
            </Modal>

            <DirectorHistoryModal isOpen={directorHistoryModal.open} onClose={() => setDirectorHistoryModal({ open: false, payrollCompanyId: 0, companyName: "" })} payrollCompanyId={directorHistoryModal.payrollCompanyId} companyName={directorHistoryModal.companyName} />

            <AddBranch isOpen={branchDrawerOpen} onClose={() => setBranchDrawerOpen(false)} payrollCompany={selectedPayrollCompany} />

            <CompanyDocumentDrawer isOpen={documentDrawerOpen} onClose={() => setDocumentDrawerOpen(false)} payrollCompany={selectedPayrollCompany} type="PAYROLL" />
        </MyDiv>
    )
};

export default PayrollCompany;